module.exports = __webpack_public_path__ + "static/media/pic_fenxiang.840bf25b.png";